"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style2, _style3;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _formStyleTypes = require("./formStyleTypes");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultProps = {
  componentName: "basicForm",
  cms: {
    style: _defineProperty({
      container: "Container size",
      background: "Form background",
      bodycolor: "Title color",
      inputBg: "Input background",
      inputFontSize: "Input font size",
      borderColor: "Border color",
      inputColor: "Input color",
      inputRadius: "Input shape",
      placeholderColor: "Placeholder color",
      placeholderFontSize: "Placeholder font size ",
      buttonBg: "Button Background",
      buttonHoverBg: "Hover background",
      buttonColor: "Color",
      buttonRadius: "Button shape",
      buttonBorderColor: "Border color",
      buttonHoverColor: "Hover color",
      buttonHoverBorderColor: "Hover Border color",
      buttonFont: "font size"
    }, "buttonRadius", "Button shape"),
    media: {
      email: "Email address"
    },
    content: {
      formTitle: "Title text ",
      fullName: "Full name",
      email: "Email",
      number: "Number",
      city: "City",
      message: "Message text",
      button: "Submit text"
    }
  },
  styleType: {
    style: (_style2 = {
      container: _extends({}, _formStyleTypes.containerSize),
      background: { type: "color" },
      bodycolor: { type: "color" },
      inputBg: { type: "color" },
      inputFontSize: { type: "textField" },
      borderColor: { type: "color" },
      inputColor: { type: "color" },
      inputRadius: { type: "textField" },
      placeholderColor: { type: "color" },
      placeholderFontSize: { type: "textField" },
      buttonFont: { type: "textField" },
      buttonBg: { type: "color" },
      buttonHoverBg: { type: "color" },
      buttonColor: { type: "color" },
      buttonRadius: { type: "textField" },
      buttonBorderColor: { type: "color" },
      buttonHoverColor: { type: "color" },
      buttonHoverBorderColor: { type: "color" }
    }, _defineProperty(_style2, "buttonFont", { type: "textField" }), _defineProperty(_style2, "buttonRadius", { type: "textField" }), _style2),
    media: {
      email: "input"
    }
  },

  props: {
    style: (_style3 = {
      container: "",
      background: "#f2f4f8",
      bodycolor: "#212529",
      inputBg: "",
      inputColor: "#495057",
      inputFontSize: "16",
      inputRadius: "2",
      placeholderColor: "#495057",
      placeholderFontSize: "13",
      borderColor: "",
      buttonFont: "16",
      buttonBg: "#f2f4f8",
      buttonHoverBg: "",
      buttonColor: "#212529",
      buttonRadius: "2",
      buttonBorderColor: "#212529",
      buttonHoverColor: "",
      buttonHoverBorderColor: ""
    }, _defineProperty(_style3, "buttonFont", "16"), _defineProperty(_style3, "buttonRadius", "3"), _style3),
    media: {
      email: ""
    },
    content: {
      formTitle: "<span>Contact form</span>",
      fullName: "Full name",
      email: "Email",
      number: "Number",
      city: "City",
      message: "Message",
      button: "Submit"
    }
  }
};
exports.default = defaultProps;